// extracted by mini-css-extract-plugin
export var pageGrid = "Layout-module--pageGrid--ZsYi1";
export var header = "Layout-module--header--3sTrQ";
export var main = "Layout-module--main--29Hot";
export var newsletter = "Layout-module--newsletter--1cJN1";
export var credits = "Layout-module--credits--mwFw3";
export var footer = "Layout-module--footer--1FzJc";